<template>
  <footer class="footer-container">
    <h5 class="footer-title">Patrocinadores Oficiales</h5>

    <div class="grid-container">
      <div v-for="(img, index) in patrocinadores" :key="index" class="card-sponsor">
        <img :src="img" alt="Sponsor" />
      </div>
    </div>
  </footer>
</template>

<script setup>
import terreno from '@/assets/images/logo_principal.png'
import xhidenxi from '@/assets/images/patrocinadores/logoXhiNegro.png'
import lgc from '@/assets/images/patrocinadores/logoLGC-full.png'
import flexi from '@/assets/images/patrocinadores/flexi.png'
import skechers from '@/assets/images/patrocinadores/skechers.png'
import laboratorio from '@/assets/images/patrocinadores/laboratorio.jpeg'
import madereria from '@/assets/images/patrocinadores/madereria_canalejas.jpeg'
import gallop from '@/assets/images/patrocinadores/gallop.jpeg'
import canteros from '@/assets/images/patrocinadores/canteros.jpeg'
import patrocinador from '@/assets/images/patrocinadores/patrocinador.jpeg'
import patroxinador2 from '@/assets/images/patrocinadores/patrocinador_2.jpeg'
import patrocinador3 from '@/assets/images/patrocinadores/patrocinador_3_lg.jpeg'
import bubbaffle from '@/assets/images/patrocinadores/BUBBAFFLE.png'
import MuebleHogar from '@/assets/images/patrocinadores/Mueble.png'

const patrocinadores = [
  lgc,
  xhidenxi,
  terreno,
  flexi,
  skechers,
  laboratorio,
  madereria,
  gallop,
  canteros,
  patrocinador,
  patroxinador2,
  patrocinador3,
  bubbaffle,
  MuebleHogar
]

</script>

<style scoped>
.footer-container {
  padding: 20px;
  background: #F6F1EC;
  border-top: 1px solid #ddd;
  text-align: center;
}

.footer-title {
  font-family: 'GYMZain', Arial sans-serif;
  font-weight: bold;
  color: #1B1E20;
  padding-bottom: 10px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 15px;
}

.card-sponsor {
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.card-sponsor img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
